import type {ColumnDef, RowData} from "@tanstack/react-table";

const STANDARD_COLUMN_IDS = {
    spa: [
        "name",
        "age",
        "spaReservations",
        "guestCount",
        "recommendations",
        "rooms",
        "countryCode",
        "nationality",
        "languageCodes",
        "stayRange",
        "medical",
        "interests",
    ],
    restaurant: [
        "name",
        "age",
        "restaurantReservations",
        "guestCount",
        "recommendations",
        "rooms",
        "countryCode",
        "nationality",
        "languageCodes",
        "stayRange",
        "allergiesAndDiets",
        "medical",
        "interests",
    ],
    crm: [
        "name",
        "ageCategories",
        "guestCount",
        "age",
        "recommendations",
        "stayStatus",
        "reservationStatus",
        "rooms",
        "start",
        "end",
        "countryCode",
        "nationality",
        "languages",
        "birthday",
        "gender",
        "allergiesAndDiets",
        "medical",
        "interests",
        "agenda",
    ],
} as const;

type DailyListKind = keyof typeof STANDARD_COLUMN_IDS;

export const applyDailyListColumnDefaults = <TData extends RowData>(
    kind: DailyListKind,
    columns: ColumnDef<TData>[],
): ColumnDef<TData>[] => {
    const standardIds = STANDARD_COLUMN_IDS[kind] as readonly string[];
    const standardColumnIds = new Set<string>(standardIds);
    const columnsById = new Map(columns.map(column => [column.id, column]));
    const orderedColumns = [
        ...standardIds.flatMap(columnId => {
            const column = columnsById.get(columnId);
            return column ? [column] : [];
        }),
        ...columns.filter(column => !column.id || !standardColumnIds.has(column.id)),
    ];

    return orderedColumns.map(column => ({
        ...column,
        meta: {
            ...column.meta,
            defaultActive: Boolean(column.id && standardColumnIds.has(column.id)),
        },
    }));
};
